import { LoadingButton } from "@dbn/omnichannel-design-system-g4p";
import {
  Props,
  useShareWithClientButtonProps,
} from "./useShareWithClientButtonProps";

export function ShareWithClientButton(props: Props) {
  const buttonProps = useShareWithClientButtonProps(props);
  return (
    <LoadingButton
      {...buttonProps}
      type="submit"
      variant="primary"
      size="default"
      data-test-id="share_with_client_button"
    />
  );
}
